import NewsAPI, {NewsArticleType} from '../api/news-api';
import Utility from './utility';

class NewsContainer {
    newsContainers: NodeListOf<HTMLElement>;

    constructor() {
        this.init();
    }

    init() {
        let self = this;
        // START: <news-container>
        class NewsContainerElement extends HTMLDivElement {
            constructor() { super(); }
        }
        customElements.define('news-container', NewsContainerElement, { extends: 'div' });
        // END: <news-container>

        this.newsContainers = document.querySelectorAll("news-container");
        if (this.newsContainers) {
            this.newsContainers.forEach(function(newContainer: HTMLElement) {
                let id = newContainer.id;
                let limit = Number(newContainer.dataset.limit);
                let infiniteScroll = newContainer.dataset.infinite;
                let displayType = newContainer.dataset.type;
                let strictFilter: string = newContainer.dataset.strict;
                let filters = newContainer.dataset.filters;
                let strictFilterBool: boolean;
                let newsAPI = new NewsAPI(newContainer, displayType);

                // is this a strict query to the API? Strict will require all matching filters.
                if (strictFilter == "yes") {
                    strictFilterBool = true;
                } else {
                    strictFilterBool = false;
                }

                // just keep loading results on senti interestion
                if (infiniteScroll == "yes") {
                    const sentinel = document.createElement('div');
                    sentinel.classList.add('news-senti');
                    newContainer.parentElement.appendChild(sentinel);
                    newContainer.dataset.page = "0";
                    const observer = new IntersectionObserver((entries) => {
                        entries.forEach((entry) => {
                            if (entry.isIntersecting)
                            {
                                // call more
                                let page = parseInt(newContainer.dataset.page);
                                if (newContainer.dataset.maxPages) {
                                    let maxPages = parseInt(newContainer.dataset.maxPages)
                                    if (page < maxPages) {
                                        page = page + 1;
                                        newContainer.dataset.page = page.toString();
                                        newsAPI.get(NewsArticleType.Mixed, filters, strictFilterBool, limit, page);
                                    }
                                }
                            }
                        });
                    });
                    observer.observe(sentinel);
                }
                
                filters.split(',').forEach((value) => {
                    newsAPI.filters.push({
                        name: value,
                        value: value
                    });
                });
                // get news
                newsAPI.get(NewsArticleType.Mixed, filters, strictFilterBool, limit);
            });
        }
    }
}
export default NewsContainer;